<template>
    <div class="container landing21">
        <div class="section1">
            <video autoplay muted loop playsinline id="bg-video">
                <source src="../../../assets/c21/ani.mp4" type="video/mp4">
            </video>
            <span class="logo">
                <img src="../../../assets/c21/ico-logo-pc.png" alt="soldoc+">
            </span>
            <div class="content" v-intersect>
                <span>관심과 성원에 감사드려요</span>
                <h1>비대면진료 부문<br>소비자만족지수<br><span class="text-blue">[</span>&nbsp;&nbsp;&nbsp;1위&nbsp;&nbsp;&nbsp;<span class="text-blue">]</span></h1>
                <p>2024. 04 한경비즈니스 소비자만족지수<br>비대면진료 부문 1위</p>
            </div>
            <div class="motion-area">
                <img src="../../../assets/c21/img-section1-1.png" alt="" class="motion-img1 infinite" v-intersect>
                <img src="../../../assets/c21/img-section1-2.png" alt="" class="motion-img2 infinite" v-intersect>
                <img src="../../../assets/c21/img-section1-3.png" alt="" class="motion-img3 infinite" v-intersect>
            </div>
        </div>
        <div class="section2" ref="section2" @scroll="handleScroll">
            <div class="content">
                <h2 v-intersect>보내주신<br>사랑과 관심에<br>감사드려요</h2>
                <ul class="card-area" v-intersect>
                    <li><img src="../../../assets/c21/img-section2-1.png" alt="한국 소비자만족지수 비대면진료 부문 1위"></li>
                    <li><img src="../../../assets/c21/img-section2-2.png" alt="2023년 보건복지부 장관상 수상"></li>
                    <li><img src="../../../assets/c21/img-section2-3.png" alt="솔닥 소비자만족지수(NPS) 93점"></li>
                    <li><img src="../../../assets/c21/img-section2-4.png" alt="앱 스토어 평점 4.9점"></li>
                    <li><img src="../../../assets/c21/img-section2-5.png" alt="재방문율 80%"></li>
                    <li><img src="../../../assets/c21/img-section2-6.png" alt="누적 앱 다운로드 건 수 10만+"></li>
                </ul>
                <ul class="explanation" v-intersect>
                    <li><span class="star">*</span>2024년 한경비즈니스 주최 소비자만족지수 비대면진료 부문 1위</li>
                    <li><span class="star">**</span>2023년 4차 산업혁명 파워코리아 대전 보건복지부 장관상 수상</li>
                    <li><span class="star">***</span>2022년 1분기 ~ 2024년 1분기 기준</li>
                </ul>
            </div>
            <div class="motion-area">
                <img src="../../../assets/c21/img-section2-7.png" alt="" class="motion-img1" v-intersect>
                <img src="../../../assets/c21/img-section2-8.png" alt="" class="motion-img2" v-intersect>
            </div>
        </div>
        <div class="section3">
            <div class="content">
                <div v-intersect>
                    <span class="subject">솔닥이 걸어온 길</span>
                    <h3>의료의 디지털<br>전환을 선도해요</h3>
                </div>
                <div class="history-list" v-intersect>
                    <ul>
                        <li>
                            <strong>한국경제주관 소비자만족 대상 수상</strong>
                            <span class="date">2024.04</span>
                        </li>
                        <li>
                            <strong>솔닥, 중소벤처기업부 장관상 수상</strong>
                            <span class="date">2023.12</span>
                        </li>
                        <li>
                            <strong>솔닥, 보건복지부 장관상 수상</strong>
                            <span class="date">2023.07</span>
                        </li>
                        <li>
                            <strong>서울 부산시 주관 우수 스타트업 선정</strong>
                            <span class="date">2022.11</span>
                        </li>
                        <li>
                            <strong>원격진료 처방 및 의약품 배송 관련 기술 특허 등록</strong>
                            <span class="date">2022.10</span>
                        </li>
                        <li>
                            <strong>비대면진료를 이용한 환자 서비스 관련 기술 특허 등록</strong>
                            <span class="date">2022.10</span>
                        </li>
                        <li>
                            <strong>업계 최초 ESG 경영 적합 판정</strong>
                            <span class="date">2022.09</span>
                        </li>
                        <li>
                            <strong>연세대학교와 헬스케어 AI분석 공동 특허 등록</strong>
                            <span class="date">2021.12</span>
                        </li>
                        <li>
                            <strong>비대면진료를 위한 인공지능 기반 기술 특허 등록</strong>
                            <span class="date">2021.12</span>
                        </li>
                        <li>
                            <strong>보건복지부 비대면진료 특화 사업체 선정</strong>
                            <span class="date">2021.06</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="section4">
            <div class="content">
                <div v-intersect>
                    <span class="subject">솔닥 서비스 소개</span>
                    <h3>모두에게 쉽고<br>편한 의료환경을<br>제공해요</h3>
                </div>
                <div class="slide-area" v-intersect>
                    <carousel 
                        ref="carousel"
                        class="service-introduction-slider"
                        :per-page="1"
                        :loop="true"
                        :speed="1500"
                        :autoplay-timeout="3000"
                        :autoplay-hover-pause="false"
                        :scroll-per-page="false"
                        :navigation-enabled="false"
                        :pagination-enabled="true"
                        :autoplay="autoplay"
                        >
                        <slide
                            v-for="(slide, index) in slides"
                            :key="index"
                            :class="['slide-item', `slide-item${index + 1}`]"
                        >
                            <div class="container" :class="{'fade-in-down': currentSlide === index}" >
                                <ul class="label-area">
                                    <li>{{ slide.label1 }}</li>
                                    <li>{{ slide.label2 }}</li>
                                    <li v-if="slide.label3">{{ slide.label3 }}</li>
                                </ul>
                                <strong class="title">{{ slide.title }}</strong>
                                <div class="image-area"></div>
                                <p class="subject" v-html="slide.subject"></p>
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
        <div class="section5">
            <div class="content">
                <div v-intersect>
                    <span class="label">EVENT</span>
                    <h3>솔닥을<br>응원해주세요</h3>
                    <p>앞으로도 더욱 성장할 솔닥을<br>축하하고 응원해주세요</p>
                </div>
                <img src="../../../assets/c21/img-section5-1.png" alt="" v-intersect>
            </div>
        </div>
        <div class="section6">
            <div class="content">
                <div v-intersect>
                    <span class="sub-title"><span class="label">EVENT</span>소비자만족 1위 기념</span>
                    <h3><strong>1,111</strong>분께 드려요</h3>
                    <p class="subject">감사의 마음을 담아 추첨을 통해<br>솔닥이 풍성한 선물을 드려요</p>
                </div>
                <img src="../../../assets/c21/img-section6-1.png" alt="신세계상품권 네이버페이" class="img" v-intersect>
                <div class="event-goods" v-intersect>
                    <h4>이벤트 상품</h4>
                    <ul class="event-list">
                        <li><strong>신세계상품권</strong>
                            <dl>
                                <dt>100,000원</dt>
                                <dd><img src="../../../assets/c21/img-section6-2.png" alt="">1명</dd>
                            </dl>
                            <dl>
                                <dt>10,000원</dt>
                                <dd>10명</dd>
                            </dl>
                        </li>
                        <li><strong>네이버페이</strong>
                            <dl>
                                <dt>5,000원</dt>
                                <dd>100명</dd>
                            </dl>
                            <dl>
                                <dt>1,000원</dt>
                                <dd>1,000명</dd>
                            </dl>
                        </li>
                    </ul>
                </div>
                <div class="tip" v-intersect>
                    <strong><span>!</span>당첨 확률 상승 TIP</strong>
                    <p>의견을 정성스럽게 남겨주실 수록<br><span>당첨 확률</span>이 올라갑니다!</p>
                </div>
                <div class="period" v-intersect>
                    <h4>참여 기간</h4>
                    <p>2024년 6월 12일(수) - 7월 10일(수)</p>
                </div>
                <div class="product-payment" v-intersect>
                    <h4>상품 지급</h4>
                    <p>2024년 7월 17일(수)</p>
                </div>
            </div>
        </div>
        <div class="section7">
            <div class="content">
                <div v-intersect>
                    <span class="subject">NOTICE</span>
                    <h4>꼭 확인해주세요!</h4>
                </div>
                <ul v-intersect>
                    <li>중복참여 및 부정참여가 발각될 경우 추후 이벤트<br> 참여가 제한됩니다.</li>
                    <li>개인정보는 당첨자 확인 및 경품 전달의 목적 이외<br>로 활용하지 않으며, 이벤트 종료 후 30일 이내 파<br>기됩니다.</li>
                    <li>본 이벤트는 사전 통보 없이 종료될 수 있습니다.</li>
                </ul>
            </div>
        </div>
        <a href="https://smore.im/form/lncIoePOhh" target="_blank" title="새 창" class="btn-cta" :class="{ 'show': showButton }">솔닥 응원하고 이벤트 참여하기 <img src="../../../assets/c21/ico-btn-arrow.png" alt=""></a>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
	name: "c21",
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
        autoplay: true,
        currentSlide: null,
        showButton: false,
        slides: [
            {
            label1: '진료예약',
            label2: '자동결제',
            label3: '서류발급',
            title: '바로솔닥',
            subject: '병원 찾기부터 병원 예약, 결제와<br>서류 발급까지 바로솔닥 앱 하나로<br>간편하게 해결하세요',
            },
            {
            label1: '시니어케어',
            label2: '비대면진료',
            label3: '',
            title: '바로돌봄',
            subject: '장기요양기관, 경로당, 장애인 시설 등에서<br>도입하여 이용할 수 있는<br>솔닥만의 원격진료 솔루션을 경험하세요',
            },
            {
            label1: '제휴병원',
            label2: 'CRM',
            label3: 'EMR',
            title: '솔닥파트너스',
            subject: '솔닥 제휴 의료진에게만 제공되는<br>특별한 혜택을 경험하고<br>앞서나가는 의료 서비스를 제공하세요',
            }
        ],
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.currentSlide = 0;
            this.$refs.carousel.$on('input', (newIndex) => {
                this.currentSlide = newIndex;
            });
        });
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            const section2 = this.$refs.section2;
            const btnCta = document.querySelector('.btn-cta');
            if (section2.getBoundingClientRect().top <= 700) {
                this.showButton = true;
                btnCta.classList.add('show');
            } else {
                this.showButton = false;
                btnCta.classList.remove('show');
            }
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            }, 5);
        }
    },
    directives: {
        intersect: {
            inserted(el) {
                const options = {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.1
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (el.classList.contains('infinite')) {
                                el.classList.add('visible');
                                setTimeout(() => {
                                    el.classList.add('play');
                                    el.classList.remove('visible');
                                }, 1000);
                            } else {
                                el.classList.add('visible');
                            }
                        } else {
                            if (el.classList.contains('infinite')) {
                                el.classList.remove('play');
                                el.classList.add('visible');
                            } else {
                                el.classList.remove('visible');
                            }
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el);
            }
        }
    }
};
</script>

<style scoped>
    .landing21 {animation-duration: 1.2s; animation-delay: 0.5s;}
    @keyframes fadeInUp {
        from {opacity: 0; transform: translate3d(0, 40px, 0);}
        to {opacity: 1; transform: translate3d(0, 0, 0);}
    }
    @keyframes float {
        0% {opacity: 1; transform: translateY(0);}
        50% {opacity: 1; transform: translateY(-12px);}
        100% {opacity: 1; transform: translateY(0);}
    }
    .visible {animation: fadeInUp 1.2s ease forwards; transition-delay: 0.5s;}
    .play {animation: float 2s ease-in-out infinite;}
    ul {list-style: none; margin: 0; padding: 0;}
	.container {position: relative;	width: 100%; max-width: 800px; margin: 0 auto; padding: 0; overflow: hidden;}
    .section1 {position: relative; width: 100%; height: 1488px; overflow: hidden;}
    #bg-video {position: absolute; top: 50%; left: 50%; min-width: 100%; min-height: 100%; width: auto; height: auto; z-index: -1; transform: translate(-50%, -50%); object-fit: cover;}
    .section1 .logo {position: absolute; top: 74px; left: calc(50% - 80px); width: 160px; height: 32px;}
    .section1 .logo img {display: block; width: 100%;}
    .section1 .content {position: relative; z-index: 2; width: 100%; height: 100%; padding: 524px 0 107px; text-align: center; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section1 .content span {font-size: 30px; font-weight: 600; line-height: 36px; color: white;}
    .section1 h1 {margin-top: 37px; margin-bottom: 0; font-size: 84px; font-weight: 700; line-height: 108px; color: white;}
    .section1 h1 .text-blue {font-size: 84px; font-weight: 300; line-height: 108px; color: #008DEF;}
    .section1 .content p {position: absolute; left: 0; bottom: 107px; margin: 0; width: 100%; font-size: 20px; font-weight: 400; line-height: 30px; color: #CCCCCC;}
    .section1 .motion-area {position: absolute; top: 0; left: 0; z-index: 1; width: 100%; height: 100%;}
    .section1 .motion-area img {position: absolute; display: block;}
    .section1 .motion-area .motion-img1 {top: 336px; right: 106px; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section1 .motion-area .motion-img2 {top: 470px; left: 91px; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section1 .motion-area .motion-img3 {top: 960px; right: 377px; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    
    .section2 {position: relative; width: 100%; height: 1687px;}
    .section2 .content {position: relative; z-index: 1; width: 700px; height: 100%; margin: 0 auto; padding: 233px 0 107px; text-align: center;}
    .section2 h2 {margin-bottom: 0; font-size: 84px; font-weight: 600; line-height: 106px; color: #1A1A1A; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section2 .card-area {display: flex; align-items: center; flex-wrap: wrap; justify-content: space-between; margin: 120px auto 42px; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section2 .card-area li {width: calc(50% - 7px); margin-bottom: 21px;}
    .section2 .card-area li img {display: block; width: 100%;}
    .section2 .explanation {width: 100%; text-align: left; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section2 .explanation li {font-size: 20px; font-weight: 400; line-height: 30px; color: #999999;}
    .section2 .explanation li .star {display: inline-block; min-width: 44px; color: #008DEF;}
    .section2 .motion-area {position: absolute; top: 0; left: 0; width: 100%; height: 100%;}
    .section2 .motion-area .motion-img1 {position: absolute; z-index: 2; top: 202px; left: 518px; display: block; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section2 .motion-area .motion-img2 {position: absolute; z-index: 2; top: 450px; left: 172px; display: block; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}

    .section3 {position: relative; width: 100%; height: 1924px; background: url(../../../assets/c21/img-section3-1.png) 0 bottom no-repeat; background-size: 100%;}
    .section3 .content {width: 100%; height: 100%; margin: 0 auto; padding: 108px 0 58px; text-align: center;}
    .section3 .content > div {opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section3 .content .subject {font-weight: 600; font-size: 30px; line-height: 36px; color: #008DEF;}
    .section3 h3 {margin-top: 32px; margin-bottom: 0; font-weight: 600; font-size: 78px; line-height: 102px; color: #1A1A1A;}
    .section3 .history-list {position: relative; margin-top: 131px; padding-left: 63px; text-align: left;}
    .section3 .history-list::before {content: ''; position: absolute; top: 15px; left: 68px; width: 1px; height: 1334px; background: url(../../../assets/c21/img-section3-2.png) 0 0 no-repeat;} 
    .section3 .history-list li {position: relative; display: inline-flex; flex-direction: column; align-items: flex-start; padding-left: 58px;}
    .section3 .history-list li::before {content: ''; position: absolute; top: 10px; left: 0; width: 11px; height: 11px; border-radius: 50%; background: #008DEF;}
    .section3 .history-list li + li {margin-top: 50px;} 
    .section3 .history-list li strong {font-weight: 600; font-size: 30px; line-height: 1; color: #1A1A1A;}
    .section3 .history-list li .date {margin-top: 21px; font-weight: 400; font-size: 26px; line-height: 1; color: #999999;}

    .section4 {position: relative; width: 100%; height: 1840px;}
    .section4 .content {width: 100%; height: 100%; margin: 0 auto; padding: 43px 0 92px; text-align: center;}
    .section4 .content > div {opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section4 .content .subject {font-weight: 600; font-size: 30px; line-height: 36px; color: #008DEF;}
    .section4 h3 {margin-top: 32px; margin-bottom: 0; font-weight: 600; font-size: 78px; line-height: 102px; color: #1A1A1A;}
    .section4 .slide-area {width: 100%; margin-top: 100px;}
    .service-introduction-slider {display: flex; height: 100%;}
    .service-introduction-slider .slide-item {flex: 0 0 auto; width: 700px; background-size: auto 1231px; margin: 0 50px; border: 1px solid #CCCCCC; border-radius: 21px; }
    .service-introduction-slider .slide-item .container {height: 1231px; padding: 123px 0 208px;}
    .service-introduction-slider .label-area {display: flex; align-items: center; justify-content: center; gap: 10px; height: 50px;}
    .service-introduction-slider .label-area li {height: 100%; padding: 0 20px; border-radius: 6px; background: #EBF7FE; font-size: 26px; font-weight: 600; color: #008DEF; line-height: 50px;}
    .service-introduction-slider .title {display: block; margin: 50px 0 74px; font-size: 60px; font-weight: 600; line-height: 42px; color: #000000;}
    .service-introduction-slider .image-area {position: relative; width: 464px; height: 464px; margin: 0 auto 81px; border-radius: 50%; background: #EBF7FE;}
    .service-introduction-slider .slide-item1 .image-area::before {content: ''; position: absolute; top: -11px; left: 29px; width: 374px; height: 494px; background: url(../../../assets/c21/img-section4-1.png) 0 0 no-repeat;}
    .service-introduction-slider .slide-item2 .image-area::before {content: ''; position: absolute; top: 0; left: -19px; width: 475px; height: 463px; background: url(../../../assets/c21/img-section4-2.png) 0 0 no-repeat;}
    .service-introduction-slider .slide-item3 .image-area::before {content: ''; position: absolute; top: -1px; left: 22px; width: 429px; height: 474px; background: url(../../../assets/c21/img-section4-3.png) 0 0 no-repeat;}
    .service-introduction-slider .slide-item .subject {margin-bottom: 0; font-size: 30px; font-weight: 400; line-height: 46px; color: #666666;}
    .section4 .slide-area >>> .VueCarousel-pagination {position: absolute; left: 50px; bottom: 108px; width: 700px;}
    .section4 .slide-area >>> .VueCarousel-dot-container {width: 128px; margin: 0 auto !important; display: flex !important; gap: 28px !important;}
    .section4 .slide-area >>> .VueCarousel-dot {margin: 0 !important; padding: 0 !important; width: 24px !important; height: 24px !important; background: #CCCCCC !important; border-radius: 50% !important;}
    .section4 .slide-area >>> .VueCarousel-dot--active {background: #008DEF !important;}

    .section5 {position: relative; width: 100%; height: 1307px;}
    .section5 .content {width: 700px; height: 100%; margin: 0 auto; padding: 100px 0 121px; border-radius: 30px; background: #F6F6F6; text-align: center;}
    .section5 .content > div {opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section5 .content .label {display: inline-flex; align-items: center; justify-content: center; width: 152px; height: 50px; background: #008DEF; border-radius: 29px; font-size: 30px; font-weight: 600; color: #fff;}
    .section5 h3 {margin-top: 32px; margin-bottom: 0; font-weight: 600; font-size: 78px; line-height: 102px; color: #1A1A1A;}
    .section5 .content p {margin: 45px 0 0; font-size: 30px; font-weight: 600; line-height: 46px; color: #1A1A1A;}
    .section5 img {display: block; margin-top: 23px; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}

    .section6 {position: relative; width: 100%; height: 3262px;}
    .section6 .content {width: 700px; height: 100%; margin: 0 auto; padding: 128px 0 206px; border-radius: 30px; background: #414351; text-align: center;}
    .section6 .content > div {opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section6 .content .sub-title {display: flex; align-items: center; justify-content: center; gap: 16px; font-size: 30px; font-weight: 600; color: #FFFFFF;}
    .section6 .content .label {display: inline-flex; align-items: center; justify-content: center; width: 152px; height: 50px; background: #008DEF; border-radius: 29px; font-size: 30px; font-weight: 600; color: #fff;}
    .section6 h3 {margin-top: 23px; margin-bottom: 0; font-weight: 600; font-size: 78px; line-height: 102px; color: #FFFFFF;}
    .section6 h3 strong {color: #008DEF;}
    .section6 .content .subject {margin: 45px 0 0; font-size: 30px; font-weight: 600; line-height: 46px; color: #FFFFFF;}
    .section6 .content .img {display: block; margin: 122px 0 0 34px; opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section6 .content .event-goods h4 {margin: 201px 0 0;}
    .section6 h4 {font-size: 60px; font-weight: 600; line-height: 102px; color: #FFFFFF;}
    .section6 .event-list {width: 100%; margin-top: 45px;}
    .section6 .event-list li {position: relative; display: flex; flex-direction: column; align-items: flex-end; padding-left: 306px; padding: 23px 45px 22px 44px; }
    .section6 .event-list li:first-child::after {content: ''; position: absolute; top: 0; left: 0; z-index: 1; width: 100%; height: 87px; background: rgba(0, 0, 0, 0.2); }
    .section6 .event-list li:first-child::before {content: ''; position: absolute; bottom: 0; left: 0; z-index: 1; width: 100%; height: 87px; background: rgba(0, 0, 0, 0.1); }
    .section6 .event-list li:last-child::after {content: ''; position: absolute; top: 0; left: 0; z-index: 1; width: 100%; height: 87px; background: rgba(0, 0, 0, 0.2); }
    .section6 .event-list li:last-child::before {content: ''; position: absolute; bottom: 0; left: 0; z-index: 1; width: 100%; height: 87px; background: rgba(0, 0, 0, 0.1); }
    .section6 .event-list li strong {position: absolute; left: 0; top: 24px; z-index: 2; padding: 0 44px; font-size: 38px; font-weight: 600; line-height: 42px; color: #FFFFFF;}
    .section6 .event-list li dl {position: relative; z-index: 2; display: flex; align-items: center; margin: 0; color: #FFFFFF;}
    .section6 .event-list li dl + dl {margin-top: 45px;}
    .section6 .event-list li dl dt {font-size: 40px; font-weight: 600; line-height: 42px; text-align: right;}
    .section6 .event-list li dl dd {display: inline-flex; align-items: center; justify-content: flex-end; gap: 8px; min-width: 158px; margin: 0; font-size: 30px; font-weight: 400; line-height: 42px;}
    .section6 .event-list li:first-child dl:nth-child(2) {color: #FEC722;}
    .section6 .event-list li:first-child dl:nth-child(3) {color: #FFEAAA;}
    .section6 .event-list li:last-child dl:nth-child(2) {color: #FFF8E2;}
    .section6 .tip {position: relative; width: 611px; height: 193px; margin: 100px auto 0; border-radius: 20px; border: 2px solid #008DEF; background: #343641;}
    .section6 .tip strong {position: absolute; top: -28px; left: calc(50% - 155px); display: inline-flex; align-items: center; gap: 15px; width: 310px; height: 56px; padding: 0 9px; border-radius: 28px; background: #008DEF; font-size: 30px; font-weight: 600; line-height: 42px; color: #FFFFFF;}
    .section6 .tip strong span {display: inline-block; width: 40px; height: 40px; background: #FFFFFF; border-radius: 50%; font-size: 38px; line-height: 40px; text-align: center; color: #008DEF;}
    .section6 .tip p {margin-bottom: 0; margin-top: 63px; font-size: 30px; font-weight: 400; line-height: 42px; color: #FFFFFF;}
    .section6 .tip p span {text-decoration: underline; text-underline-offset: 4px;}
    .section6 .period h4 {margin: 192px 0 38px;}
    .section6 .period p {margin-top: 0; font-size: 38px; font-weight: 600; line-height: 42px; color: #FFFFFF;}
    .section6 .product-payment h4 {margin: 176px 0 38px;}
    .section6 .product-payment p {margin-top: 0; font-size: 38px; font-weight: 600; line-height: 42px; color: #FFFFFF;}

    .section7 {position: relative; width: 100%; height: 733px; margin-bottom: 426px;}
    .section7 .content > div {opacity: 0; transform: translate3d(0, 40px, 0); transition: opacity 0.5s ease-out, transform 0.5s ease-out;}
    .section7 .content {width: 700px; height: 100%; margin: 0 auto; padding: 114px 0 102px; border-radius: 30px; background: #EBF7FE; text-align: center;}
    .section7 .content .subject {font-weight: 600; font-size: 30px; line-height: 36px; color: #008DEF;}
    .section7 h4 {margin-top: 12px; margin-bottom: 0; font-weight: 600; font-size: 60px; line-height: 102px; color: #1A1A1A;}
    .section7 ul {margin: 41px 0 0 48px;}
    .section7 ul li {position: relative; padding-left: 27px; font-size: 30px; font-weight: 400; line-height: 50px; color: #666666; text-align: left;}
    .section7 ul li::before {content: ''; position: absolute; top: 21px; left: 0; width: 6px; height: 6px; border-radius: 50%; background: #666666;}

    .btn-cta {text-decoration: none; display: inline-flex; align-items: center; justify-content: center; gap: 22px; position: fixed; bottom: 65px; z-index: 10; left: calc(50% - 350px); width: 700px; height: 118px; border-radius: 20px; background: #008DEF; font-size: 34px; font-weight: 600; color: #FFFFFF; opacity: 0; transition: opacity 1s;}
    .btn-cta.show {opacity: 1;}
</style>


// WEBPACK FOOTER //
// src/components/pc_view/contents/c21.vue